import { useNavigate } from "react-router-dom";
import { genderConverter } from "../../../utils/Functions";
import Table from "../../common/table";

const ProfileList = ({ data, count = 10 }: any) => {
  const navigate = useNavigate();

  const TdComponent = ({ children }: any) => {
    return <td className="whitespace-nowrap text-sm">{children}</td>;
  };

  return (
    <div>
      <div className="overflow-x-auto">
        <Table
          header={[
            "",
            "نام",
            "تعداد آزمایش‌ها",
            "کاربران زیرمجموعه",
            "شماره همراه",
            "جنسیت",
          ]}
          body={data.results
            ?.slice(0, count)
            .map((result: any, idx: number) => (
              <tr
                className="cursor-pointer hover duration-300 border-gray-100"
                key={idx}
                onClick={() => navigate(`/dashboard-profiles/${result.id}`)}
              >
                <TdComponent>{idx + 1}</TdComponent>
                <TdComponent>
                  {result.user?.first_name
                    ? `${result.user?.first_name} ${result.user?.last_name}`
                    : "وارد نشده"}
                </TdComponent>
                <TdComponent>{result.test_count}</TdComponent>
                <TdComponent>{result.temp_user_count}</TdComponent>
                <TdComponent>{result.mobile}</TdComponent>
                <TdComponent>{genderConverter(result.gender)}</TdComponent>
              </tr>
            ))}
        />
      </div>
    </div>
  );
};

export default ProfileList;
